import { useEffect, useState } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { APP_PATH } from "../api/backendPath";
import { CONSULTATION_TYPE_STORAGE_KEY } from "../constants/consultationTypes";

/**
 * The logged-in doctor's consultation type ("video" | "onsite" | "video-onsite").
 *
 * Starts from the value cached in sessionStorage, then confirms it with
 * GET /auth/verification-status (which always returns it) and caches the result.
 * Screens reached before anything else has cached the type, such as the
 * onboarding upload-documents page, still get the right value this way.
 * Returns null until the type is known.
 */
export default function useDoctorConsultationType() {
  const axiosPrivate = useAxiosPrivate();
  const [consultationType, setConsultationType] = useState(
    () => sessionStorage.getItem(CONSULTATION_TYPE_STORAGE_KEY) || null,
  );

  useEffect(() => {
    let cancelled = false;

    const fetchConsultationType = async () => {
      try {
        const response = await axiosPrivate.get(
          `${process.env.REACT_APP_API_URL}${APP_PATH.verificationStatus}`,
        );
        const fetched = response?.data?.data?.consultation_type;
        if (cancelled || !fetched) return;
        sessionStorage.setItem(CONSULTATION_TYPE_STORAGE_KEY, fetched);
        setConsultationType(fetched);
      } catch (error) {
        // Keep the cached value; the backend still validates the documents.
        console.warn("Could not load the doctor's consultation type:", error);
      }
    };

    fetchConsultationType();
    return () => {
      cancelled = true;
    };
  }, [axiosPrivate]);

  return consultationType;
}
